// removed by extract-text-webpack-plugin
module.exports = {"centered-text":"components-InfoModal-__index__centered-text__1Ao7L","color-1":"components-InfoModal-__index__color-1__3e-KS","color-2":"components-InfoModal-__index__color-2__oi8kz","color-3":"components-InfoModal-__index__color-3__39vYm","color-4":"components-InfoModal-__index__color-4__3TB0O","color-5":"components-InfoModal-__index__color-5__3z4y0"};


//////////////////
// WEBPACK FOOTER
// ./components/InfoModal/index.css
// module id = 804
// module chunks = 0